import defaultJson from './default.json';

export default {
  defaultJson
};
